// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2sWGl","alertIcon":"ConfirmModal_alertIcon__lhjFL"};